/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import Glide from "@glidejs/glide";

// Initialize Our Team Card Slider
const ourTeamCardSliderHandler = () => {
	const teamSliders = document.querySelectorAll(".our-team-card-listing__glide");

	teamSliders.forEach((slider, i) => {
		const autoplay = slider.dataset.autoplay;
		const slidesPerView = slider.dataset.slidesPerView;
		
		// Check if the slider has already been initialized
		if (!slider.hasAttribute("data-initialized")) {
			new Glide(slider, {
				type: "carousel",
				startAt: 0,
				perView: Number(slidesPerView),
				autoplay: Number(autoplay),
				gap: 25,
				breakpoints: {
					1024: { perView: Math.min(Number(slidesPerView), 3) },
					640: { perView: 1, peek: 40 },
				},
			}).mount();
			
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");
		}
	});
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	ourTeamCardSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		ourTeamCardSliderHandler();
	});
}